import React, { useState } from 'react';

const Tooltip = ({
  message,
  show = false,
  position = 'bottom',
  children,
  className = '',
  hoverOnly = false,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  if (!show) return children || null;

  const shouldShowTooltip = hoverOnly ? isHovered : true;

  const positionStyles = {
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
  };

  return (
    <div
      className="relative inline-block"
      onMouseEnter={() => hoverOnly && setIsHovered(true)}
      onMouseLeave={() => hoverOnly && setIsHovered(false)}
    >
      {children}
      {shouldShowTooltip && (
        <div
          className={`
            absolute z-50 px-3 py-2 text-sm text-white bg-gray-900 rounded-lg shadow-lg
            whitespace-nowrap
            ${positionStyles[position]}
            ${className}
          `}
        >
          {message}
          <div
            className={`
              absolute w-2 h-2 bg-gray-900 transform rotate-45
              ${position === 'bottom' ? 'top-0 left-1/2 -translate-x-1/2 -translate-y-1/2' : ''}
              ${position === 'top' ? 'bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2' : ''}
              ${position === 'left' ? 'right-0 top-1/2 -translate-y-1/2 translate-x-1/2' : ''}
              ${position === 'right' ? 'left-0 top-1/2 -translate-y-1/2 -translate-x-1/2' : ''}
            `}
          />
        </div>
      )}
    </div>
  );
};

export default Tooltip;
